// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ShoppingBagIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ShoppingBag/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M16 11V7a4 4 0 0 0-8 0v4M5 9h14l1 12H4L5 9Z"
}));
export default ShoppingBagIcon;